export default "__VITE_ASSET__DowF4GpA__";